// TODO: update all places with usage of subscription type
export const subscriptionNames = {
  homebuyer: {
    basic: "homebuyer_basic",
    premium: "homebuyer_premium",
  },
  agent: {
    basic: "agent_basic",
    basic10: "agent_basic_10",
    basicFree: "agent_basic_free",
    premium: "agent_zip_code",
  },
  "loan officer": {
    basic: "loan_officer_basic",
    basic10: "loan_officer_basic_10",
    basicFree: "loan_officer_basic_free",
    premium: "loan_officer_state",
  },
};
